module.exports = __webpack_public_path__ + "img/Spain.61190087.png";